



























import { Component, Vue } from "vue-property-decorator";
import { ScoreboardSummary } from "@/api";
import ScoreboardSummaryCard from "@/components/scoreboard/ScoreboardSummaryCard.vue";
import loading from "@/components/loader/loading.vue";

@Component({
  components: { ScoreboardSummaryCard, loading },
})
export default class CultureScoreboard extends Vue {
  eventName = this.$route.query.eventName;

  created() {
    let startDate, endDate;
    if (this.stateStartDate) {
      startDate = this.stateStartDate;
    }
    if (this.stateEndDate) {
      endDate = this.stateEndDate;
    }
    this.$store.dispatch("scoreboard/loadCompanyCultureScoreboard", {
      employeeId: this.$route.query.empId,
      departmentId: this.$route.query.deptId,
      leaderBoardDescending: this.$route.params.id === "-20" ? true : false,
      beginAt: startDate,
      endAt: endDate,
    });
  }

  get stateStartDate() {
    return this.$store.getters["scoreboard/startDate"];
  }

  get stateEndDate() {
    return this.$store.getters["scoreboard/endDate"];
  }

  get scoreboards(): ScoreboardSummary[] {
    return this.$store.getters["scoreboard/cultureScoreboards"];
  }
  back() {
    this.$router.back();
  }
}
